import React from 'react';
import { func, element, string, bool } from 'prop-types';
import { SpanButton, Underline } from './RoleButton.style';

const RoleButton = ({
  children = undefined,
  underlineType = 'none',
  onClick = () => {},
  shouldHighLight = false,
  ...remainingProps
}) => {
  const handleUserInteraction = (event) => {
    // keyborad activation with enter or space is allowed to support WCAG
    if (event.nativeEvent instanceof KeyboardEvent && event.key !== 'Enter' && event.key !== ' ') {
      return;
    }
    onClick();
  };

  return (
    <>
      <SpanButton
        role="button"
        tabIndex={0}
        onClick={handleUserInteraction}
        onKeyPress={handleUserInteraction}
        underline={underlineType === 'default'}
        shouldHighLight={shouldHighLight}
        {...remainingProps}
      >
        {children}

        {underlineType === 'padding' && <Underline />}
      </SpanButton>
    </>
  );
};

RoleButton.propTypes = {
  children: element.isRequired,
  underlineType: string.isRequired,
  onClick: func.isRequired,
  shouldHighLight: bool,
};

RoleButton.defaultProps = {
  shouldHighLight: false,
};

export default RoleButton;
